// import axios from 'axios'
// import { API_BASE_URL } from './api';
// const BASE_URL = `${API_BASE_URL}/auth`;

// // Login with email and password
// export const login = async (email, password) => {
//   try {
//     const response = await axios.post(`${BASE_URL}/login`, { email, password });
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || { message: 'Login failed' };
//   }
// };

// // Register new user
// export const register = async (userData) => {
//   try {
//     const response = await axios.post(`${BASE_URL}/register`, userData);
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || { message: 'Registration failed' };
//   }
// };

// // Convert Twitter access token to JWT
// export const convertTwitterToken = async (accessToken) => {
//   try {
//     const tweetId = localStorage.getItem("selected_tweet_id");
//     const reply = localStorage.getItem("selected_tweet_reply");
 
//     const response = await axios.post(`${BASE_URL}/twitter-to-jwt`, {
//       accessToken,
//       tweetId,
//       reply
//     });
//     console.log(response.data,"convertTwitterTokenResponse");
//     return response.data;
//   } catch (error) {
//     if (error.response?.status === 429) {
//       const retryAfter = error.response.headers?.['retry-after'] ||
//                          error.response.data?.retryAfter;
 
//       throw {
//         isRateLimit: true,
//         retryAfter: parseInt(retryAfter, 10),
//         message: 'Twitter rate limit exceeded. Please try again later.',
//         ...error.response?.data
//       };
//     }
 
//     throw error.response?.data || { message: 'Twitter authentication failed' };
//   }
// };
 
// //get reply id for tweet
// export const getReplyIdForTweet = async ()=>{
//   try {
//     const tweetId = localStorage.getItem("selected_tweet_id");
//     const response = await axios.post(`${API_BASE_URL}/reply-id`, {
//       tweetId
//     });
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || { message: 'Failed to get reply ID' };
//   }
// }
// // Logout
// export const logout = () => {
//   localStorage.removeItem('token');
//   localStorage.removeItem('twitter_access_token');
// };

// // Check if user is authenticated
// export const isAuthenticated = () => {
//   return !!localStorage.getItem('token');
// };

// export default {
//   login,
//   register,
//   convertTwitterToken,
//   logout,
//   isAuthenticated
// };

// import axios from 'axios'
// import { API_BASE_URL } from './api';
// const BASE_URL = `${API_BASE_URL}/auth`;

// // Login with email and password
// export const login = async (email, password) => {
//   try {
//     const response = await axios.post(`${BASE_URL}/login`, { email, password });
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || { message: 'Login failed' };
//   }
// };

// // Register new user
// export const register = async (userData) => {
//   try {
//     const response = await axios.post(`${BASE_URL}/register`, userData);
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || { message: 'Registration failed' };
//   }
// };

// // Convert Twitter access token to JWT
// export const convertTwitterToken = async (accessToken) => {
//   try {
//     const tweetId = localStorage.getItem("selected_tweet_id");
//     const reply = localStorage.getItem("selected_tweet_reply");
 
//     const response = await axios.post(`${BASE_URL}/twitter-to-jwt`, {
//       accessToken,
//       tweetId,
//       reply
//     });
//     console.log(response.data,"convertTwitterTokenResponse");
//     return response.data;
//   } catch (error) {
//     if (error.response?.status === 429) {
//       const retryAfter = error.response.headers?.['retry-after'] ||
//                          error.response.data?.retryAfter;
 
//       throw {
//         isRateLimit: true,
//         retryAfter: parseInt(retryAfter, 10),
//         message: 'Twitter rate limit exceeded. Please try again later.',
//         ...error.response?.data
//       };
//     }
 
//     throw error.response?.data || { message: 'Twitter authentication failed' };
//   }
// };
 
// //get reply id for tweet
// export const getReplyIdForTweet = async ()=>{
//   try {
//     const tweetId = localStorage.getItem("selected_tweet_id");
//     const response = await axios.post(`${API_BASE_URL}/reply-id`, {
//       tweetId
//     });
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || { message: 'Failed to get reply ID' };
//   }
// }
// // Logout
// export const logout = () => {
//   localStorage.removeItem('token');
//   localStorage.removeItem('twitter_access_token');
// };

// // Check if user is authenticated
// export const isAuthenticated = () => {
//   return !!localStorage.getItem('token');
// };

// export default {
//   login,
//   register,
//   convertTwitterToken,
//   logout,
//   isAuthenticated
// };


import axios from 'axios'
import { API_BASE_URL } from './api'
import { jwtDecode } from 'jwt-decode'
 
const BASE_URL = `${API_BASE_URL}/auth`
 
// ======================
// 🔑 Token Helpers
// ======================
export const getToken = () => localStorage.getItem("token")
 
export const setToken = (token) => localStorage.setItem("token", token)
 
export const clearToken = () => {
  localStorage.removeItem("token")
  localStorage.removeItem("user") // agar user details bhi save kar rahe ho
}
 
export const logout = () => {
  // 🔥 LocalStorage + SessionStorage cleanup
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("accounts");
  localStorage.removeItem("twitter_accounts");
  sessionStorage.clear();
 
  // Agar tum clearToken() aur backend cleanup bhi karte ho to wo bhi call kar lo
  clearToken?.();
 
  // 🔔 Custom event fire → App.js / AuthContext isko pakad lega
  //window.dispatchEvent(new Event("token-expired"));
 
  // ✅ Redirect to login
  window.location.href = "/";
};
 
// ======================
// Auth APIs
// ======================
 
// Login with email and password
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/login`, { email, password })
    return response.data
  } catch (error) {
    throw error.response?.data || { message: 'Login failed' }
  }
}
 
// Register new user
export const register = async (userData) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, userData)
    return response.data
  } catch (error) {
    throw error.response?.data || { message: 'Registration failed' }
  }
}
 
// Convert Twitter access token to JWT
export const convertTwitterToken = async (accessToken) => {
  try {
    const tweetId = localStorage.getItem("selected_tweet_id")
    const reply = localStorage.getItem("selected_tweet_reply")
 
    const response = await axios.post(`${BASE_URL}/twitter-to-jwt`, {
      accessToken,
      tweetId,
      reply
    })
    console.log(response.data, "convertTwitterTokenResponse")
    return response.data
  } catch (error) {
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers?.['retry-after'] ||
                         error.response.data?.retryAfter
 
      throw {
        isRateLimit: true,
        retryAfter: parseInt(retryAfter, 10),
        message: 'Twitter rate limit exceeded. Please try again later.',
        ...error.response?.data
      }
    }
 
    throw error.response?.data || { message: 'Twitter authentication failed' }
  }
}
 
// get reply id for tweet
export const getReplyIdForTweet = async () => {
  try {
    const tweetId = localStorage.getItem("selected_tweet_id")
    const response = await axios.post(`${API_BASE_URL}/reply-id`, {
      tweetId
    })
    return response.data
  } catch (error) {
    throw error.response?.data || { message: 'Failed to get reply ID' }
  }
}
 
// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('token')
}
 
// ======================
// ⏰ Auto Logout Timer
// ======================
let logoutTimer;

export const startTokenTimer = (token) => {
  if (logoutTimer) clearTimeout(logoutTimer);

  try {
    const { exp } = jwtDecode(token); // JWT decode karo
    let expiryTime = exp * 1000 - Date.now();

    console.log("⏰ Token will expire in:", expiryTime / 1000, "seconds");

    logoutTimer = setTimeout(() => {
      console.log("🚪 Token expired, auto logout...");
      clearToken();
      window.dispatchEvent(new Event("token-expired"));
      console.log("🔔 token-expired event dispatched"); // ✅ debug
    }, expiryTime);
  } catch (err) {
    console.error("❌ Failed to decode token expiry", err);
  }
};


export default {
  login,
  register,
  convertTwitterToken,
  logout,
  isAuthenticated,
  getToken,
  setToken,
  clearToken,
  startTokenTimer
}
 
 